export default __webpack_public_path__ + "static/about-block-3-33e9af75ddbdbf888ce20f2f124f6a70.jpg";